"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _filters = require("@/filters");
var _permission = require("@/utils/permission");
var _productEnums = require("@/enums/productEnums");
var _reservation = require("@/api/reservation");
var _dialogDispatch = _interopRequireDefault(require("./dialogDispatch"));
var _dialogReschedule = _interopRequireDefault(require("./dialogReschedule"));
var _systemFromInfo = _interopRequireDefault(require("@/views/order/components/systemFromInfo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'WorkOrderDetail',
  components: {
    dialogDispatch: _dialogDispatch.default,
    dialogReschedule: _dialogReschedule.default,
    systemFromInfo: _systemFromInfo.default
  },
  props: {
    workOrderNo: {
      type: String,
      default: 0
    }
  },
  data: function data() {
    return {
      OrderSecondTypeEnum: _productEnums.OrderSecondTypeEnum,
      activeName: 'detail',
      direction: 'rtl',
      reverse: true,
      dialogVisible: false,
      orderDatalist: {},
      loading: false,
      result: [],
      resultInfo: {},
      InvoiceList: [],
      refundInfo: {},
      editData: {},
      reservationFormData: [],
      //系统表单数据,用户下单填写
      serviceEvidenceForm: [],
      //系统表单数据,用户下单填写
      expressName: '',
      //快递名称
      productList: [] //商品信息
    };
  },
  watch: {},
  mounted: function mounted() {},
  methods: {
    checkPermi: _permission.checkPermi,
    // 派单
    handleDispatch: function handleDispatch(type) {
      this.$refs.dialogDispatchRef.openBox(type, this.orderDatalist);
    },
    // 改约
    handleRescheduling: function handleRescheduling() {
      this.$refs.dialogRescheduleRef.openBox();
    },
    // 服务时长
    getTimes: function getTimes() {
      var str = '';
      if (this.orderDatalist.serviceStartTime && this.orderDatalist.serviceEndTime) {
        var startTime = this.orderDatalist.serviceStartTime;
        var endTime = this.orderDatalist.serviceEndTime;
        var formatISOTime = function formatISOTime(timeStr) {
          return timeStr.replace(' ', 'T') + 'Z';
        };
        var start = new Date(formatISOTime(startTime));
        var end = new Date(formatISOTime(endTime));

        // 计算时间差
        var diffMs = end - start;
        var diffMinute = Math.ceil(diffMs / 60000);
        return (diffMinute > 0 ? diffMinute : 1) + '分钟'; // 1分钟 = 60,000毫秒
      } else {
        return str = '--';
      }
    },
    orderRefundStatusFilter: _filters.orderRefundStatusFilter,
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 操作回调
    selectStaff: function selectStaff() {
      this.getDetail(this.workOrderNo);
      this.$emit('changeStaff');
    },
    getDetail: function getDetail(id) {
      var _this = this;
      this.loading = true;
      (0, _reservation.workOrderDetailApi)(id).then(function (res) {
        _this.orderDatalist = res;
        _this.reservationFormData = res.reservationFormData ? JSON.parse(res.reservationFormData) : [];
        _this.serviceEvidenceForm = res.serviceEvidenceForm ? JSON.parse(res.serviceEvidenceForm) : [];
        _this.activeName = 'detail';
        _this.productList = res.orderDetail ? [res.orderDetail] : [];
        _this.loading = false;
      }).catch(function () {
        _this.orderDatalist = null;
        _this.loading = false;
      });
    }
  }
};